import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizFinishedTranslations: Quiz409Translations = {
  title: 'Quiz terminé !',
  subMessage: 'Tu as terminé toutes les tâches du quiz.',
  buttons: {
    back: 'Accueil',
  },
};
